import { styled } from 'twin.macro';

const MasterClassContainer = styled.div`
  .masterclass-font {
    font-family: 'Inter', sans-serif;
  }
  .masterclass-secondary-font {
    font-family: 'DM Serif Display', serif;
  }
  .container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
  }
  .bg-spriteImg {
    background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/masterclass-sprite.svg');
    display: inline-block;
    background-position: -231px -128px;
  }
  .header {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  }

  .master-next-image span {
    height: 100% !important;
    display: block !important;
  }

  .swiper-wrapper {
    transition-timing-function: linear !important;
  }

  .h1-heading span {
    display: inline-block;
    color: #ffffff;
    line-height: 68px;
    position: relative;
    // padding: 0 10px;
    // margin: 0 -10px;
    // background-image: linear-gradient( to bottom right, transparent 50%, #3FB48A 50% ), linear-gradient(#3FB48A, #3FB48A), linear-gradient(to top left, transparent 50%, #3FB48A 50%);
    // background-repeat: no-repeat;
    // background-size: 4px 68px, calc(100% - 8px) 68px, 4px 68px;
    // background-position: left center, center, right;
    background: #3fb48a;
    transform: skew(-4deg);
    padding: 0 2px;
  }

  .PrimarybuttonIcon {
    background-position: -130px -60px;
  }
  .program-list::before {
    background-position: -3px -138px;
    background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/masterclass-sprite.svg');
  }
  .testimonial-list::before {
    background-position: -938px -60px;
    background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/masterclass-sprite.svg');
  }
  .testimonial_wrap {
    box-shadow: 0px 0px 16px rgba(24, 39, 75, 0.05);
  }

  .qutation-icon {
    background-position: -188px -141px;
  }
  .rate-icon {
    background-position: -48px -139px;
  }
  .user-desg::after {
    background-position: 119px -61px;
  }
  .logo-acc {
    background-position: -580px -210px;
    width: 86px;
    height: 23px;
  }
  .logo-amz {
    background-position: -689px -210px;
    width: 73px;
    height: 23px;
  }
  .logo-adobe {
    background-position: -785px -211px;
    width: 80px;
    height: 21px;
  }
  .logo-cong {
    background-position: -888px -211px;
    width: 94px;
    height: 21px;
  }
  .logo-delo {
    background-position: -1007px -213px;
    width: 90px;
    height: 17px;
  }
  .logo-capz {
    background-position: -1122px -210px;
    width: 98px;
    height: 23px;
  }
  .logo-ms {
    background-position: 0px -211px;
    width: 98px;
    height: 21px;
  }
  .logo-link {
    background-position: -122px -211px;
    width: 80px;
    height: 21px;
  }
  .logo-flip {
    background-position: -226px -208px;
    width: 97px;
    height: 27px;
  }
  .logo-pay {
    background-position: -347px -209px;
    width: 77px;
    height: 25px;
  }
  .logo-orac {
    background-position: -448px -214px;
    width: 109px;
    height: 15px;
  }
  .logo-gogl {
    background-position: -1244px -208px;
    width: 82px;
    height: 27px;
  }
  .left-arrow-icon::before {
    background-position: -720px -138px;
  }
  .close-btn {
    background-position: -644px -140px;
  }
  .workshop-icon1 {
    background-position: -231px -128px;
  }
  .workshop-icon2 {
    background-position: -295px -128px;
  }
  .workshop-icon3 {
    background-position: -359px -128px;
  }
  .workshop-icon4 {
    background-position: -423px -128px;
  }
  .workshop-icon5 {
    background-position: -487px -128px;
  }
  .bonus-icon-1 {
    background-position: -893px -120px;
  }
  .bonus-icon-2 {
    background-position: -973px -120px;
  }
  .bonus-icon-3 {
    background-position: -1053px -120px;
  }
  .red-circle {
    background-position: -610px -60px;
  }
  .calendar-icon {
    background-position: -2px -283px;
  }
  .timer-icon {
    background-position: -49px -283px;
  }

  .back-icon {
    background-position: -720px -138px;
  }

  .add-icon {
    background-position: -853px -138px;
  }
  .certificate-list::before {
    background-position: -1043px -54px;
    background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/masterclass-sprite.svg');
  }
  .card-wrappers {
    display: grid !important;
  }
  .blog-next {
    color: transparent !important;
    right: 30px !important;
    width: 18px !important;
    height: 12px !important;
    top: 147px !important;
    background-position: 433px 565px !important;
  }
  .blog-prev {
    color: transparent !important;
    left: 91% !important;
    width: 18px !important;
    height: 12px !important;
    top: 147px !important;
    background-position: 433px 565px !important;
    transform: rotate(180deg);
  }
  .acc-next {
    display: none !important;
  }
  .acc-prev {
    display: none !important;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .blog-pagination > .swiper-pagination-bullet {
    background-color: #525252;
    width: 6px;
    height: 6px;
    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 3px) !important;
  }
  .blog-pagination.swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: 24px !important;
  }

  .blog-pagination > .swiper-pagination-bullet-active {
    background-color: #525252;
    width: 8px;
    height: 8px;
  }
  .blog-pagination {
    text-align: left !important;
  }

  .accordion-button:not(.collapsed) {
    color: #000 !important;
    box-shadow: none !important;
  }
  .accordion-button:not(.collapsed)::after {
    color: #000 !important;
  }
  .shadow-shadowList {
    box-shadow: 0px 3px 1px rgba(255, 123, 81, 0.2) !important;
  }
  .shadow-shadowCamp {
    box-shadow: 0px 7px 1px rgba(255, 123, 81, 0.2) !important;
  }

  .shadow-shadowMd {
    box-shadow: 0px 7px 1px rgba(209, 219, 221, 0.4);
  }

  .work-box:hover {
    box-shadow: 0px 7px 1px rgba(255, 123, 81, 0.2);
  }
  .inset-center {
    left: 35%;
  }
  /* .work-box:nth-of-type(even) {margin-top: 76px;} */

  /*---blueColor-form-start--*/
  .form-group .inputText.required:focus ~ .floating-label,
  .form-control:focus ~ .floating-label,
  .form-group .inputText.required:not(:focus):valid ~ .floating-label,
  .form-group .inputText.required:not(:focus):valid ~ .floating-label {
    top: -9px;
    left: 10px;
    font-size: 12px;
    line-height: 18px;
    opacity: 1;
    color: #231f20;
    background: #fff;
    padding: 0 6px;
  }
  .form-group .inputText.required:focus:invalid ~ .floating-label {
    top: -9px;
    left: 10px;
    font-size: 12px;
    line-height: 18px;
    opacity: 1;
    color: #ec4e5d;
    background: #fff;
    padding: 0 6px;
  }
  .form-group .form-control:focus:invalid {
    border-color: #ec4e5d !important;
    color: #ec4e5d;
  }

  .containers input:checked ~ .checkmark {
    background-color: #36b067;
    border: none;
  }
  .containers input:checked ~ .checkmark:after {
    display: block;
  }
  .containers .checkmark:after {
    left: 10px;
    top: 6px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .grp-divider {
    border-bottom: 1px solid #000 !important;
  }

  .modal input:checked ~ .checkmark {
    background-color: #db4144;
    border: none;
  }
  .modal input:checked ~ .checkmark:after {
    display: block;
  }
  .modal .checkmark:after {
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .grp-divider {
    border-bottom: 1px solid #000 !important;
  }
  select.form-control {
    background-color: #fff !important;
  }
  .ws-odd {
    height: 28px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ws-even,
  .ws-all {
    height: 56px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .btn-primary {
    position: relative;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    padding: 8px 48px 8px 16px;
    color: #ffffff;
    border-radius: 4px;
  }

  .btn-primary-prefix {
    position: relative;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: #ffffff;
    border-radius: 4px;
    width: 100%;
    padding: 10px 96px 10px 56px;
  }

  .btn-primary i {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    display: inline-block;
  }
  .btn-primary-prefix i {
    position: absolute;
    top: 18%;
    left: 100px;
    display: inline-block;
  }
  .summary-icon-1 {
    background-position: -34px -58px;
    width: 24px;
    height: 27px;
    display: inline-block;
  }
  .button-header-arrow {
    background-position: -83px -62px;
    width: 21px;
    height: 20px;
  }
  .button-prefix-arrow {
    background-position: -127px -56px;
    width: 28px;
    height: 30px;
  }
  .mc-tags {
    width: 25px;
    height: 27px;
  }
  .banner-tag-1 {
    background-position: -35px -61px;
    width: 21px;
    height: 21px;
  }
  .banner-tag-2 {
    background-position: -180px -63px;
    width: 19px;
    height: 18px;
  }
  .banner-tag-3 {
    background-position: -227px -62px;
    width: 21px;
    height: 20px;
  }
  .banner-tag-4 {
    background-position: -275px -62px;
    width: 22px;
    height: 21px;
  }
  .banner-tag-5 {
    background-position: -323px -62px;
    width: 21px;
    height: 20px;
  }
  .banner-tag-6 {
    background-position: -371px -63px;
    width: 21px;
    height: 18px;
  }
  .banner-tag-7 {
    background-position: -419px -62px;
    width: 21px;
    height: 20px;
  }
  .banner-tag-8 {
    background-position: -470px -62px;
    width: 14px;
    height: 19px;
  }
  .banner-tag-9 {
    background-position: -515px -62px;
    width: 21px;
    height: 20px;
  }
  .banner-tag-10 {
    background-position: -564px -62px;
    width: 20px;
    height: 20px;
  }
  .count-active {
    display: flex;
  }
  .list-section:nth-of-type(6n + 1) {
    background: #111111;
    color: #ffffff;
  }
  .list-section:nth-of-type(6n + 2) {
    background: #f0cf65;
    color: #000000;
  }
  .list-section:nth-of-type(6n + 3) {
    background: #f0cf65;
    color: #000000;
  }
  .list-section:nth-of-type(6n + 4) {
    background: #111111;
    color: #ffffff;
  }
  .list-section:nth-of-type(6n + 5) {
    background: #111111;
    color: #ffffff;
  }
  .list-section:nth-of-type(6n + 6) {
    background: #f0cf65;
    color: #000000;
  }
  
  .red-dot-icon {
    background-position: -607px -56px;
    width: 30px;
    height: 30px;
    display: inline-block;
  }
  .icon-calender {
    background-position: -657px -58px;
    width: 26px;
    height: 28px;
    display: inline-block;
  }
  
  .user-Textlimit,
  .card-limit {
    display: -webkit-box;
    -webkit-line-clamp: 7;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 210px;
    text-overflow: ellipsis;
  }

  /* faq section */

  .faq-icons {
    background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/masterclass-sprite.svg');
    background-repeat: no-repeat;
  }

  .icon-arrow-down {
    background-position: -1109px -69px;
    width: 10px;
    height: 6px;
  }

  /* .workshop-limit {-webkit-line-clamp: 2;height:36px} */
  /* .card-limit{-webkit-line-clamp: 2;height:56px} */
  /*----*/

  /*====================*/

  .section-heading-bg span {
    position: relative;
    font-family: 'DM Serif Display', serif;
    font-weight: 400;
    letter-spacing: 0.5px;
    font-style: italic;
    line-height: 54px;
    font-size: 36px;
    display: inline-block;
    margin-top: 2px;
  }

  .section-heading-bg span:before {
    content: '';
    background-repeat: no-repeat;
    background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/border-desk.svg');
    position: absolute;
    left: -3px;
    bottom: -9px;
    height: 8px;
    width: 100%;
  }

  .h1-subheading span {
    position: relative;
    display: inline-block;
  }

  .h1-subheading span:before {
    content: '';
    background-repeat: no-repeat;
    background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/heading-bg-desk.svg');
    position: absolute;
    left: -3px;
    bottom: -14px;
    height: 9px;
    width: 100%;
  }

  .h1-subheading-b2 span {
    position: relative;
    display: inline-block;
  }

  .h1-subheading-b2 span:before {
    content: '';
    background-repeat: no-repeat;
    background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/heading-bg-b2-desk.svg');
    position: absolute;
    left: -3px;
    bottom: -14px;
    height: 11px;
    width: 100%;
  }

  .section-heading-bg-color span {
    display: inline-block;
    color: #ffffff;
    background: #3fb48a;
    padding: 0 8px 0 4px;
  }
  .testimonial-wrappers .swiper-pagination-bullets.swiper-pagination-horizontal {
    text-align: left;
    margin-left: 21px;
    height: 8px;
    bottom: 24px;
    top: auto;
    display: flex;
    align-items: center;
    max-width: 200px;
  }

  .text-limit span {
    background: #fcf35d;
  }
  .user-Textlimit span {
    background: #fcf35d;
  }
  .editor-master p:first-child {
    margin-top: 0;
  }
  .editor-master ul,
  .editor-master ol {
    padding-left: 42px;
  }
  .editor-master ul li,
  .editor-master ol li {
    margin-bottom: 8px;
  }
  .editor-master ul li:last-child,
  .editor-master ol li:last-child {
    margin-bottom: 0px;
  }
  .editor-master p {
    margin-top: 19px;
    margin-bottom: 19px;
    line-height: 21px;
    color: #000000;
    font-size: 14px;
  }
  .editor-master ul li ul,
  .editor-master ul li ol,
  .editor-master ol li ul,
  .editor-master ol li ol {
    padding-left: 20px;
  }
  .editor-master ol,
  .editor-master ul {
    margin-top: 19px;
    margin-bottom: 24px;
    line-height: 21px;
    color: #000000;
    font-size: 14px;
  }
  .editor-master ul {
    list-style: disc;
  }
  .editor-master ul ul {
    list-style: circle;
  }
  .editor-master ul ul ul {
    list-style: square;
  }
  .editor-master ol {
    list-style: decimal;
  }
  .editor-master ol ol {
    list-style: upper-alpha;
  }
  .editor-master ol ol ol {
    list-style: lower-alpha;
  }
  .editor-master ol li ol,
  .editor-master ul li ul,
  .editor-master ol li ul,
  .editor-master ul li ol {
    margin-top: 0;
    margin-bottom: 0;
  }
  .editor-master a {
    color: #db4144;
  }

  /* upGrad footer icons */

  .footer-icons {
    background-image: url('https://www.upgrad.com/bootcamps/masterclass-instagram-app/images/icons/ug-master-class-sprite.svg');
    background-repeat: no-repeat;
  }
  .icon-upgrad-facebook {
    background-position: -312px -191px;
    width: 24px;
    height: 24px;
  }
  .icon-upgrad-twitter {
    background-position: -376px -193px;
    width: 25px;
    height: 20px;
  }
  .icon-upgrad-linkedin {
    background-position: -441px -191px;
    width: 24px;
    height: 24px;
  }
  .icon-upgrad-youtube {
    background-position: -505px -191px;
    width: 20px;
    height: 24px;
  }

  @media only screen and (max-width: 767px) {
    .blog-prev {
      top: 100% !important;
      left: 40% !important;
    }
    .blog-next {
      top: 100% !important;
      right: 40% !important;
    }
    .PrimarybuttonIcon {
      background-position: -7px -551px;
    }
    .testIcon-sm:before {
      background-position: -296px -546px;
    }
    .program-list:before {
      background-position: -136px -551px;
    }
    .logo-acc {
      background-position: -788px -610px;
      width: 75px;
      height: 20px;
    }
    .logo-amz {
      background-position: -887px -610px;
      width: 66px;
      height: 20px;
    }
    .logo-adobe {
      background-position: -977px -611px;
      width: 75px;
      height: 19px;
    }
    .logo-cong {
      background-position: -1076px -615px;
      width: 75px;
      height: 15px;
    }
    .logo-delo {
      background-position: -397px -616px;
      width: 75px;
      height: 14px;
    }
    .logo-capz {
      background-position: -496px -614px;
      width: 74px;
      height: 16px;
    }
    .logo-ms {
      background-position: -594px -614px;
      width: 78px;
      height: 16px;
    }
    .logo-link {
      background-position: -696px -613px;
      width: 68px;
      height: 17px;
    }
    .logo-flip {
      background-position: -203px -608px;
      width: 80px;
      height: 22px;
    }
    .logo-pay {
      background-position: -307px -609px;
      width: 66px;
      height: 21px;
    }
    .logo-orac {
      background-position: -7px -620px;
      width: 78px;
      height: 10px;
    }
    .logo-gogl {
      background-position: -109px -607px;
      width: 70px;
      height: 23px;
    }
    .bonus-icon-1 {
      background-position: -598px -539px;
    }
    .bonus-icon-2 {
      background-position: -662px -539px;
    }
    .bonus-icon-3 {
      background-position: -726px -539px;
    }
    .rate-icon {
      background-position: -340px -552px;
    }
    .qutation-icon {
      background-position: -460px -554px;
    }
    .modal-dialog {
      position: fixed !important;
      bottom: 0 !important;
      margin: 0 !important;
    }
    .work-box:nth-last-of-type(1) {
      margin-bottom: 0px;
    }
    .work-box {
      margin-bottom: 24px !important;
    }
    .bootcamp-info:last-child {
      border: none !important;
      padding-bottom: 0;
    }
    .bootcamp_list:last-child {
      border: none !important;
      padding-bottom: 10px;
    }
    .left-arrow-icon::before {
      background-position: -43px -545px;
    }
    .bootcamp-info:first-child {
      padding-top: 0;
    }
    .containers .checkmark:after {
      left: 7px;
      top: 4px;
      width: 4px;
      height: 8px;
    }
    .count-active {
      justify-content: center;
      margin: 0 0 32px 0;
    }
    .header {
      box-shadow: 0px 4px 5px 2px rgba(0, 0, 0, 0.04);
    }
    .ws-odd,
    .ws-all,
    .ws-even {
      height: auto;
      -webkit-line-clamp: inherit !important;
    }
    .section-heading-bg-color span {
      padding: 0 4px 0 2px;
    }
    .certificate-list::before {
      background-position: -496px -545px;
    }

    .section-heading-bg span {
      font-size: 24px;
      line-height: 28px;
      margin-top: 4px;
    }
    .section-heading-bg span:before {
      background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/border-mbl.svg');
      height: 4px;
      left: 0;
    }
    .h1-heading span {
      line-height: 36px;
      background: transparent;
      transform: none;
      color: #000000;
    }
    .h1-subheading span:before {
      content: '';
      background-repeat: no-repeat;
      background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/heading-bg-mobl.svg');
      position: absolute;
      left: -3px;
      bottom: -8px;
      height: 5px;
      width: 100%;
    }
    .h1-subheading-b2 span:before {
      content: '';
      background-repeat: no-repeat;
      background-image: url('https://d2o2utebsixu4k.cloudfront.net/master-class/heading-bg-b2-mobl.svg');
      position: absolute;
      left: -3px;
      bottom: -8px;
      height: 5px;
      width: 100%;
    }
    .list-section:nth-of-type(6n + 1) {
      background: #111111;
      color: #ffffff;
    }
    .list-section:nth-of-type(6n + 2) {
      background: #f0cf65;
      color: #000000;
    }
    .list-section:nth-of-type(6n + 3) {
      background: #111111;
      color: #ffffff;
    }
    .list-section:nth-of-type(6n + 4) {
      background: #f0cf65;
      color: #000000;
    }
    .list-section:nth-of-type(6n + 5) {
      background: #111111;
      color: #ffffff;
    }
    .list-section:nth-of-type(6n + 6) {
      background: #f0cf65;
      color: #000000;
    }
    .user-Textlimit,
    .card-limit {
      display: -webkit-box;
      -webkit-line-clamp: 10;
      -webkit-box-orient: vertical;
      overflow: hidden;
      height: 210px;
      text-overflow: ellipsis;
    }
    .editor-master p {
      font-size: 12px;
      line-height: 18px;
    }
    .editor-master ul li,
    .editor-master ol li {
      font-size: 12px;
      line-height: 18px;
    }
    .editor-master ul,
    .editor-master p,
    .editor-master ol {
      margin-top: 16px;
      margin-bottom: 16px;
      color: #111111;
    }
    .editor-master ul,
    .editor-master ol {
      padding-left: 30px;
    }
    .calendar-icon {
      background-position: -792px -551px;
    }
    .timer-icon {
      background-position: -831px -551px;
    }
    .red-circle {
      background-position: -92px -549px;
    }
  }
`;

export default MasterClassContainer;